import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { X, Gift, Copy, Check } from "lucide-react";
import { API } from "../App";
import axios from "axios";
import { toast } from "sonner";

const PromoBanner = ({ onClose }) => {
  const { t } = useTranslation();
  const [promo, setPromo] = useState(null);
  const [copied, setCopied] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPromo();
  }, []);

  const fetchPromo = async () => {
    try {
      const response = await axios.get(`${API}/promo/active`);
      if (response.data.promo) {
        setPromo(response.data.promo);
      }
    } catch (err) {
      console.error("Error fetching promo:", err);
    } finally {
      setLoading(false);
    }
  };

  const copyCode = () => {
    if (promo?.code) {
      navigator.clipboard.writeText(promo.code);
      setCopied(true);
      toast.success("Promo code copied!");
      setTimeout(() => setCopied(false), 2000);
    }
  };

  if (loading || !promo) return null;

  return (
    <div className="bg-gradient-to-r from-rose-500 to-pink-500 text-white py-3 px-4 relative">
      <div className="max-w-6xl mx-auto flex items-center justify-center gap-4 flex-wrap">
        <div className="flex items-center gap-2">
          <Gift className="w-5 h-5" />
          <span className="font-medium">{promo.description}</span>
        </div>
        
        <div className="flex items-center gap-2">
          <span className="text-rose-100">Use code:</span>
          <button
            onClick={copyCode}
            className="flex items-center gap-1 bg-white/20 hover:bg-white/30 px-3 py-1 rounded-full font-bold transition-colors"
            data-testid="copy-promo-code"
          >
            <span>{promo.code}</span>
            {copied ? (
              <Check className="w-4 h-4" />
            ) : (
              <Copy className="w-4 h-4" />
            )}
          </button>
        </div>
        
        <span className="text-rose-100 text-sm">
          {promo.discount_percent}% OFF
          {promo.for_new_users_only && " • New users only"}
        </span>
      </div>
      
      {onClose && (
        <button
          onClick={onClose}
          className="absolute right-4 top-1/2 -translate-y-1/2 p-1 hover:bg-white/20 rounded-full transition-colors"
        >
          <X className="w-4 h-4" />
        </button>
      )}
    </div>
  );
};

export default PromoBanner;
